import {
  MOBILE_VIEW_THRESHOLD_PX,
  ROUTE_ALLOW_NOTIFICATIONS,
  ROUTE_HOMEPAGE,
  ROUTE_LANDING,
} from '@1bill-app/constants';
import { AuthQuery } from '@1bill-app/services/auth/state/auth.query';
import { AuthStore } from '@1bill-app/services/auth/state/auth.store';
import { SettingsService } from '@1bill-app/services/settings/settings.service';
import { SettingsOptions } from '@1bill-app/services/settings/settings.store';
import { UserService } from '@1bill-app/services/user/user.service';
import { getValidationMsgs, ValidationMsgIF } from '@1bill-app/validators/messages';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { NavController, Platform } from '@ionic/angular';
import { Auth } from 'aws-amplify';
import { NGXLogger } from 'ngx-logger';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-update-name',
  templateUrl: './update-name.page.html',
  styleUrls: ['./update-name.page.scss'],
})
export class UpdateNamePage implements OnInit {
  // HIDEREFERRALCODES
  // @ViewChild('referralCodeInput') referralCodeInput: HTMLIonInputElement;
  // storedReferralCode: string;
  // fetchingReferralCode = true;

  constructor(
    private navCtrl: NavController,
    private platform: Platform,
    private settingsService: SettingsService,
    private logger: NGXLogger,
    private authStore: AuthStore,
    private authQuery: AuthQuery,
    private userService: UserService,
    private router: Router,
  ) {
    this.updateNameForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
    });
    this.validationMsgs = getValidationMsgs();
    if (this.router.routerState.snapshot.root.queryParamMap.get('socialSignInAuth') == '1') {
      this.hideNameInput = true;
      this.socialSignInAuth = true;
    }
  }
  /**
   * Whether or not to hide name input as the name would already be submitted in the database
   * (e.g. by social sign in.)
   */
  hideNameInput = false;
  /**
   * Set by a query parameter from AuthService after user registration is completed, indicating
   * that the user has not entered a code and used social sign-in auth.
   * If using social sign-in auth, the user does not need to enter a name as the name will be
   * set automatically by the third-party auth provider. This page should only be visited if
   * the user has not submitted a referral code.
   */
  socialSignInAuth = false;
  updateNameForm: FormGroup;
  loading: boolean;
  showValidationError = false;
  serverValidationError: string = null;
  get isDesktopView() {
    return this.platform.width() >= MOBILE_VIEW_THRESHOLD_PX;
  }
  // landingPage = ROUTE_LANDING;
  validationMsgs: ValidationMsgIF;

  get firstNameCtrl() {
    return this.updateNameForm.get('firstName');
  }
  get lastNameCtrl() {
    return this.updateNameForm.get('lastName');
  }

  get firstNameClass() {
    return (this.showValidationError &&
      this.firstNameCtrl.invalid &&
      this.firstNameCtrl.touched) ||
      this.serverValidationError
      ? 'error'
      : '';
  }
  get lastNameClass() {
    return (this.showValidationError &&
      this.lastNameCtrl.invalid &&
      this.lastNameCtrl.touched) ||
      this.serverValidationError
      ? 'error'
      : '';
  }

  async ngOnInit() {
    // HIDEREFERRALCODES
    // this.fetchingReferralCode = true;
    this.authQuery
      .select('hasName')
      .pipe(
        filter((hasName) => hasName),
        take(1),
      )
      .subscribe((hasName) => {
        this.hideNameInput = true;
        // TODO: When unhiding referral codes, remove the below line.
        // This line is to ensure that users are not stuck on this page where they should be
        // adding referral codes.
        this.router.navigateByUrl(ROUTE_HOMEPAGE);
        // HIDEREFERRALCODES
        // if (!this.fetchingReferralCode) {
        //   // Navigate to homepage as no need to enter name and the
        //   // referral code is already known to not need submission.
        //   this.navCtrl.navigateRoot(ROUTE_HOMEPAGE);
        // }
      });
    // Only check whether or not there is a referral code if the user has not signed in via
    // third-party auth. The route to this page from AuthService after third-party sign-in
    // checks that the user does not have a referral code before routing to this page, so
    // it's unnecessary to call the `getInputReferralCode` API again.
    if (!this.socialSignInAuth) {
      // HIDEREFERRALCODES
      // await this.userService
      //   .getInputReferralCode()
      //   .then(async (refCode: { code: string; fromLocalStorage: boolean } | null) => {
      //     this.fetchingReferralCode = false;

      //     // Name input and referral code input shows conditionally. This function should be used
      //     // to check if neither conditions are true, so nothing would be displayed on the page.
      //     if (this.hideNameInput) {
      //       if (refCode.fromLocalStorage) {
      //         // Submit referral code if it is saved via local storage (by ref link).
      //         this.userService.submitReferralCode(
      //           await this.userService.getUserEmail(),
      //           refCode.code,
      //         );
      //       }
      //       // No content to be displayed if else.
      //       this.navCtrl.navigateRoot(ROUTE_HOMEPAGE);
      //       return;
      //     }

      //     this.storedReferralCode = refCode?.code;
      //   });
    } else {
      // HIDEREFERRALCODES
      // this.fetchingReferralCode = false;
    }
  }

  async onClickNext() {
    this.showValidationError = true;
    this.updateNameForm.markAllAsTouched();

    if (!this.updateNameForm.valid && !this.hideNameInput) return;
    // get form values
    const firstName = this.firstNameCtrl.value;
    const lastName = this.lastNameCtrl.value;

    // process
    this.loading = true;

    const payload: SettingsOptions = { option: 'NAME', settingsData: { firstName, lastName } };

    // HIDEREFERRALCODES
    // const referralCode =
    //   this.storedReferralCode || (this.referralCodeInput?.value as string)?.trim();
    // if (referralCode?.length) {
    //   const userEmail =
    //     this.authStore.getValue().email ??
    //     (await Auth.currentUserInfo().then((userInfo) => userInfo.attributes.email as string));
    //   await this.userService.submitReferralCode(userEmail, referralCode).toPromise();
    // }

    // *** IMPORTANT: saveNames call must come after submitReferralCode. This is because user referral codes
    // *** can only be entered during signup, and for better user experience, users can enter referral codes
    // *** after creating an account. The referralCodes API will check if the user has a name set, and if they
    // *** do, the referral code submission will be cancelled, as the referral code submission did not happen
    // *** during (or just after - before entering first and last name) signup.

    if (this.hideNameInput) {
      //If on mobile device, navigate to "allow-notifications" page.
      //Otherwise, navigate to homepage.
      this.navCtrl.navigateRoot(
        Capacitor.isNativePlatform() ? ROUTE_ALLOW_NOTIFICATIONS : ROUTE_HOMEPAGE,
      );
    } else {
      this.settingsService.saveNames(payload).subscribe({
        next: (result) => {
          this.authStore.update({ hasName: true });
          this.logger.debug('signup result: ', result);
          this.updateNameForm.reset();
          this.showValidationError = false;
          this.serverValidationError = null;

          //If on mobile device, navigate to "allow-notifications" page.
          //Otherwise, navigate to homepage.
          this.navCtrl.navigateRoot(
            Capacitor.isNativePlatform() ? ROUTE_ALLOW_NOTIFICATIONS : ROUTE_HOMEPAGE,
          );

          this.loading = false;
        },
        error: (err) => {
          this.logger.error('onClickSignup', err);
          this.serverValidationError = 'Something went wrong. Please try again later.';
          this.loading = false;
        },
      });
    }
  }

  onClickClose() {
    this.navCtrl.navigateRoot(ROUTE_HOMEPAGE);
  }

  signOut() {
    Auth.signOut();
    this.navCtrl.navigateRoot(ROUTE_LANDING);
  }
}
